export default {
    mapSpeedOverrideDeleteSpeedOverride_title:'Delete Speed Overrides',
    mapSpeedOverrideDeleteSpeedOverride_title_detail:'Are you sure you want to delete the following speed overrides?',
    mapSpeedOverrideDeleteSpeedOverride_warning:'This action cannot be undone.',
    mapSpeedOverrideDeleteSpeedOverride_success:'Speed overrides deleted',
}